import React, { Component } from "react";
import { isValidArray } from "../../helper";
import { filter, get, isFunction, isNull } from "lodash";
import PropTypes from "prop-types";
import { filterNames } from "./filter.selector";
import { getLocalstorage } from "../../helper";
import { Modal, Button, Image, Form } from "react-bootstrap";
import { QuickFilterSearch } from "../reusableComponent/search/Quickfiltersearch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import QuickFilterIcon from "../../assets/search_icon.png";
import CrossIcon from "../../assets/Vector 441.svg";
import NoDataFound from "../../component/NoDataFound";
class PragatiIssueQuickFilter extends Component {
  isDataLoaded = false;
  state = {
    search: {},
    selectedFilters: {},
    sortedListingArr: [],
    quickfilterdata: ["Monitoring Flag"],
    selectall: false,
    MonitoringFlag: [],
    ProjectStatus: [],
    ProjectStage: [],
    model_open: false,
    quickfilterdatanew: ["Monitoring Flag"],
    RecipientState: [],
    RecipientMinistry: [],
    IssueLocation: [],
    IssueZone: [],
    IssueStages: [],
    issueZoneFilterdata: [],
    IssueCategory: [],
    IssueSponsoringMinistry: [],
    displayNamefilter: ["Monitoring Flag"],
    StaticCheckboxData: [],
    propsCheckedData: [],
    ProjectGroupby: [
      {
        key: "projectGroupBy",
        displayName: "Project",
        count: null,
        checked: false
      }
    ],
    issueFilterID: [],
    selectedFilters: [],
    selectalltext: true,
    searchedtext: "",
    projectFlagsFilterdata: [],
    recipientStateFilterdata: [],
    recipientCenterFilterdata: [],
    centerStateFilterdata: [],
    stagesFilterdata: [],
    categoryFilterdata: [],
    sponsoringMinistryFilterdata: [],
    projectTagsFilterdata: [],
    projectStageFilterdata: [],
    projectFlagsEmpty: false,
    recipientStateEmpty: false,
    recipientCenterEmpty: false,
    centerStateEmpty: false,
    stagesFilterdataEmpty: false,
    categoryFilterdataEmpty: false,
    sponsoringMinistryEmpty: false,
    projectTagsEmpty: false,
    projectStageEmpty: false,
    issuesZoneEmpty: false
  };
  handleCross = searchedFilterList => {
    this.setState({ searchedtext: "", selectall: false });
    const { filterData, AgendaIssueStage } = this.props;
    if (this.state.quickfilterdata.includes("Monitoring Flag")) {
      const updatedArray1 = filterData.projectFlags.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Monitoring Flag") // Generate unique IDs using index
        })
      );
      if (searchedFilterList.length == this.state.MonitoringFlag.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectFlagsFilterdata: updatedArray1,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Recipient State")) {
      const updatedArray2 = filterData.recipientState.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Recipient State") // Generate unique IDs using index
        })
      );
      if (searchedFilterList.length == this.state.RecipientState.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        recipientStateFilterdata: updatedArray2,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Recipient Ministry")) {
      const updatedArray3 = filterData.recipientCenter.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Recipient Ministry") // Generate unique IDs using index
        })
      );
      if (searchedFilterList.length == this.state.RecipientMinistry.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        recipientCenterFilterdata: updatedArray3,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Zone")) {
      const updatedArray5 = filterData.issueZones.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Zone") // Generate unique IDs using index
      }));
      if (searchedFilterList.length == this.state.IssueZone.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        issueZoneFilterdata: updatedArray5,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Issue Location")) {
      const updatedArray4 = filterData.centerState.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Location") // Generate unique IDs using index
      }));
      if (searchedFilterList.length == this.state.IssueLocation.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        centerStateFilterdata: updatedArray4,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Issue Stages")) {
      if (AgendaIssueStage == true) {
        const targetNames = [
          "Pending with PMG",
          "Pending with RM/RS",
          "Pending with SM",
          "Under PMG Decision"
        ];
        const updatedArray5 = filterData.stages.values.map((obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Stages") // Generate unique IDs using index
        }));
        const filteredArray = updatedArray5.filter(item => {
          return targetNames.includes(item.displayName);
        });
        this.setState({ stagesFilterdata: filteredArray, selectalltext: true });
      } else {
        const updatedArray5 = filterData.stages.values.map((obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Stages") // Generate unique IDs using index
        }));
        this.setState({ stagesFilterdata: updatedArray5, selectalltext: true });
      }
      if (searchedFilterList.length == this.state.IssueStages.length) {
        this.setState({ selectall: true });
      }
    } else if (this.state.quickfilterdata.includes("Issue Category")) {
      const updatedArray6 = filterData.category.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Category") // Generate unique IDs using index
      }));
      if (searchedFilterList.length == this.state.IssueCategory.length) {
        this.setState({ selectall: true });
      }
      this.setState({ categoryFilterdata: updatedArray6, selectalltext: true });
    } else if (
      this.state.quickfilterdata.includes("Issue Sponsoring Ministry")
    ) {
      const updatedArray7 = filterData.sponsoringMinistry.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Sponsoring Ministry") // Generate unique IDs using index
        })
      );
      if (
        searchedFilterList.length == this.state.IssueSponsoringMinistry.length
      ) {
        this.setState({ selectall: true });
      }
      this.setState({
        sponsoringMinistryFilterdata: updatedArray7,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Status")) {
      let usersWithoutTim = filterData.projectStatus.values.filter(
        user =>
          user.key !== "NO_COMPLETION_STAGE" && user.key !== "NO_IMPLEMENTATION"
      );
      const updatedArray8 = usersWithoutTim.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Project Status") // Generate unique IDs using index
      }));
      if (searchedFilterList.length == this.state.ProjectStatus.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectTagsFilterdata: updatedArray8,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Stage")) {
      const updatedArray9 = filterData.projectStage.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Project Stage") // Generate unique IDs using index
        })
      );
      if (searchedFilterList.length == this.state.ProjectStage.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        projectStageFilterdata: updatedArray9,
        selectalltext: true
      });
    } else {
    }
  };
  handleFilterSelection = filter => {
    const updatedFilters = [...this.state.issueFilterID];

    if (updatedFilters.includes(filter)) {
      updatedFilters.splice(updatedFilters.indexOf(filter), 1);
    } else {
      updatedFilters.push(filter);
    }

    this.setState({ issueFilterID: updatedFilters }, () => {
      //console.log(this.state.issueFilterID)
    });
    this.props.onFilterChange(updatedFilters);
  };
  componentDidMount() {
    const { filterData } = this.props;
    // const newCheckedData=checkedData.map((obj,index)=>{
    //   obj["id"] = this.randId(index,obj.displayName)
    // })
    this.setState({
      filtersSortedData: filterData
      //propsCheckedData:newCheckedData
    });
  }

  getFilteredData = (sortedListingArr, name) => {
    this.setState(prevState => {
      return {
        sortedListingArr: {
          ...prevState.sortedListingArr,
          [name]: sortedListingArr
        },
        isSearching: get(sortedListingArr, "isSearching")
      };
    });
  };

  handleSubmit = () => {
    const {
      onChange1,
      onChange2,
      onChange3,
      onChange4,
      onChange5,
      onChange6,
      onChange7,
      onChange8,
      onChange9,
      onChange10
    } = this.props;
    localStorage.setItem("ClearAll", JSON.stringify(false));
    this.state.quickfilterdatanew.map(e => {
      if (e == "Monitoring Flag") {
        var element = this.state.MonitoringFlag.map(item => {
          return item;
        });

        isFunction(onChange1) &&
          onChange1(element, "projectFlags", "QuickFilter");
        this.setState({ model_open: false });
      } else if (e == "Recipient State") {
        var element = this.state.RecipientState.map(item => {
          return item;
        });

        isFunction(onChange2) &&
          onChange2(element, "recipientState", "QuickFilter");
      } else if (e == "Recipient Ministry") {
        var element = this.state.RecipientMinistry.map(item => {
          return item;
        });

        isFunction(onChange3) &&
          onChange3(element, "recipientCenter", "QuickFilter");
      } else if (e == "Zone") {
        var element = this.state.IssueZone.map(item => {
          return item;
        });
        isFunction(onChange10) &&
          onChange10(element, "issueZones", "QuickFilter");
      } else if (e == "Issue Location") {
        var element = this.state.IssueLocation.map(item => {
          return item;
        });
        isFunction(onChange4) &&
          onChange4(element, "centerState", "QuickFilter");
      } else if (e == "Issue Stages") {
        var element = this.state.IssueStages.map(item => {
          return item;
        });
        isFunction(onChange5) && onChange5(element, "stages", "QuickFilter");
      } else if (e == "Issue Category") {
        var element = this.state.IssueCategory.map(item => {
          return item;
        });
        isFunction(onChange6) && onChange6(element, "category", "QuickFilter");
      } else if (e == "Issue Sponsoring Ministry") {
        var element = this.state.IssueSponsoringMinistry.map(item => {
          return item;
        });
        isFunction(onChange7) &&
          onChange7(element, "sponsoringMinistry", "QuickFilter");
      } else if (e == "Project Status") {
        var element = this.state.ProjectStatus.map(item => {
          return item;
        });
        isFunction(onChange8) &&
          onChange8(element, "projectStatus", "QuickFilter");
      } else if (e == "Project Stage") {
        var element = this.state.ProjectStage.map(item => {
          return item;
        });
        isFunction(onChange9) &&
          onChange9(element, "projectStage", "QuickFilter");
      } else {
        // Handle other conditions
      }
      const combinedFilters = this.state.MonitoringFlag.map(flag => ({
        ...flag,
        filterName: "projectFlags"
      }));
      //this.state.ProjectGroupby.map(flag => ({ ...flag ,"filterName":"projectGroupBy"}));
      // combinedFilters.push(...this.state.MonitoringFlag.map(filter => ({ ...filter ,"filterName":"projectFlags"})));
      combinedFilters.push(
        ...this.state.RecipientState.map(filter => ({
          ...filter,
          filterName: "recipientState"
        }))
      );
      combinedFilters.push(
        ...this.state.IssueZone.map(filter => ({
          ...filter,
          filterName: "issueZones"
        }))
      );
      combinedFilters.push(
        ...this.state.RecipientMinistry.map(filter => ({
          ...filter,
          filterName: "recipientCenter"
        }))
      );
      combinedFilters.push(
        ...this.state.IssueLocation.map(filter => ({
          ...filter,
          filterName: "centerState"
        }))
      );
      combinedFilters.push(
        ...this.state.IssueStages.map(filter => ({
          ...filter,
          filterName: "stages"
        }))
      );
      combinedFilters.push(
        ...this.state.IssueCategory.map(filter => ({
          ...filter,
          filterName: "category"
        }))
      );
      combinedFilters.push(
        ...this.state.IssueSponsoringMinistry.map(filter => ({
          ...filter,
          filterName: "sponsoringMinistry"
        }))
      );
      combinedFilters.push(
        ...this.state.ProjectStatus.map(filter => ({
          ...filter,
          filterName: "projectStatus"
        }))
      );
      combinedFilters.push(
        ...this.state.ProjectStage.map(filter => ({
          ...filter,
          filterName: "projectStage"
        }))
      );
      this.setState({ selectedFilters: combinedFilters }, () => {
        this.props.onFilterChange(this.state.selectedFilters);
      });
    });
  };
  handleOpen = () => {
    this.setState({
      model_open: true,
      MonitoringFlag: [],
      ProjectStage: [],
      ProjectStatus: [],
      RecipientState: [],
      RecipientMinistry: [],
      IssueZone: [],
      IssueLocation: [],
      IssueStages: [],
      IssueCategory: [],
      quickfilterdata: ["Monitoring Flag"],
      IssueSponsoringMinistry: [],
      propsCheckedData: [],
      issueFilterID: [],
      searchedtext: "",
      selectalltext: true,
      selectall: false
    });
    const {
      checkedData,
      staticFilterData,
      AgendaIssueStage,
      filterData
    } = this.props;
    //console.log(filterData.projectStatus)
    let usersWithoutTim = filterData.projectStatus.values.filter(
      user =>
        user.key !== "NO_COMPLETION_STAGE" && user.key !== "NO_IMPLEMENTATION"
    );
    //console.log(usersWithoutTim)
    let flagid = filterData.projectFlags.values;
    const updatedArray1 = flagid.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Monitoring Flag") // Generate unique IDs using index
    }));
    //console.log(updatedArray1)
    const updatedArray2 = filterData.recipientState.values.map(
      (obj, index) => ({
        ...obj,
        id: this.randId(index, "Recipient State") // Generate unique IDs using index
      })
    );
    const updatedArray3 = filterData.recipientCenter.values.map(
      (obj, index) => ({
        ...obj,
        id: this.randId(index, "Recipient Ministry") // Generate unique IDs using index
      })
    );
    const updatedArray4 = filterData.centerState.values.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Issue Location") // Generate unique IDs using index
    }));
    if (AgendaIssueStage == true) {
      const targetNames = [
        "Pending with PMG",
        "Pending with RM/RS",
        "Pending with SM",
        "Under PMG Decision"
      ];
      const updatedArray5 = filterData.stages.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Stages") // Generate unique IDs using index
      }));
      const filteredArray = updatedArray5.filter(item => {
        return targetNames.includes(item.displayName);
      });
      this.setState({ stagesFilterdata: filteredArray });
    } else {
      const updatedArray5 = filterData.stages.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Stages") // Generate unique IDs using index
      }));
      this.setState({ stagesFilterdata: updatedArray5 });
    }
    const updatedArray6 = filterData.category.values.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Issue Category") // Generate unique IDs using index
    }));
    const updatedArray7 = filterData.sponsoringMinistry.values.map(
      (obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Sponsoring Ministry") // Generate unique IDs using index
      })
    );
    const updatedArray8 = usersWithoutTim.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Project Status") // Generate unique IDs using index
    }));

    const updatedArray9 = filterData.projectStage.values.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Project Stage") // Generate unique IDs using index
    }));
    const updatedArray10 = filterData.issueZones.values.map((obj, index) => ({
      ...obj,
      id: this.randId(index, "Zone") // Generate unique IDs using index
    }));
    this.setState(
      {
        projectFlagsFilterdata: updatedArray1,
        recipientStateFilterdata: updatedArray2,
        recipientCenterFilterdata: updatedArray3,
        centerStateFilterdata: updatedArray4,
        categoryFilterdata: updatedArray6,
        sponsoringMinistryFilterdata: updatedArray7,
        projectTagsFilterdata: updatedArray8,
        projectStageFilterdata: updatedArray9,
        issueZoneFilterdata: updatedArray10
      },
      () => {
        if (this.state.projectFlagsFilterdata.length == 0) {
          //console.log(this.state.MonitoringFlag)
          this.setState({
            selectall: false,
            projectFlagsEmpty: true,
            recipientStateEmpty: false,
            recipientCenterEmpty: false,
            centerStateEmpty: false,
            stagesFilterdataEmpty: false,
            categoryFilterdataEmpty: false,
            sponsoringMinistryEmpty: false,
            projectTagsEmpty: false,
            projectStageEmpty: false,
            issuesZoneEmpty: false
          });
        }
        if (
          this.state.MonitoringFlag.length ==
          this.state.projectFlagsFilterdata.length
        ) {
          this.setState({ selectall: true });
        }
        // else if(this.state.recipientStateFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:true,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.recipientCenterFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:true,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.centerStateFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:true,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.stagesFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:true,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.categoryFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:true,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.sponsoringMinistryFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:true,projectTagsEmpty:false,projectStageEmpty:false})
        // }
        // else if(this.state.projectTagsFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:true,projectStageEmpty:false})
        // }
        // else if(this.state.projectStageFilterdata.length==0){
        //   console.log(this.state.projectFlagsFilterdata)
        //   this.setState({projectFlagsEmpty:false,recipientStateEmpty:false,recipientCenterEmpty:false,centerStateEmpty:false,stagesFilterdataEmpty:false,categoryFilterdataEmpty:false,sponsoringMinistryEmpty:false,projectTagsEmpty:false,projectStageEmpty:true})
        // }
        //console.log(this.state.projectFlagsFilterdata)
      }
    );
    const filteredArray1 = checkedData.filter(
      item => item.filterName === "recipientState"
    );

    const filteredArray2 = checkedData.filter(
      item => item.filterName === "projectFlags"
    );
    const filteredArray3 = checkedData.filter(
      item => item.filterName === "recipientCenter"
    );
    const filteredArray4 = checkedData.filter(
      item => item.filterName === "centerState"
    );
    const filteredArray5 = checkedData.filter(
      item => item.filterName === "stages"
    );
    const filteredArray6 = checkedData.filter(
      item => item.filterName === "category"
    );
    const filteredArray7 = checkedData.filter(
      item => item.filterName === "sponsoringMinistry"
    );
    const filteredArray8 = checkedData.filter(
      item => item.filterName === "projectStatus"
    );
    const filteredArray9 = checkedData.filter(
      item => item.filterName === "projectStage"
    );
    const filteredArray10 = checkedData.filter(
      item => item.filterName === "issueZones"
    );
    this.setState({
      RecipientState: filteredArray1,
      MonitoringFlag: filteredArray2,
      RecipientMinistry: filteredArray3,
      IssueLocation: filteredArray4,
      IssueStages: filteredArray5,
      IssueCategory: filteredArray6,
      IssueSponsoringMinistry: filteredArray7,
      ProjectStatus: filteredArray8,
      ProjectStage: filteredArray9,
      IssueZone: filteredArray10
    });
    const { clearAll, filtersValue } = this.props;
    //console.log(filterData)
    const filtersKeysArr = Object.keys(filterData || {});
    const checkedFiltersids = new Set();
    filtersKeysArr.map(filterName => {
      const currentFilter = filterData[filterName];

      if (currentFilter && currentFilter.values) {
        currentFilter.values = this.placeCheckedFiltersOnTop(
          currentFilter.values
        );
      }

      const filterCurrentValue = filtersValue[filterName];
      const _filterName = filterNames[get(currentFilter, "displayName")];

      const searchedFilterList = this.getSearchedFilters(
        get(currentFilter, "values"),
        this.getStateFilterVal(_filterName)
      );

      if (get(currentFilter, "displayName", "NA") === "Monitoring Flag") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );

        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          checkedFiltersids.add(idFound.toString());
        } else {
          filteredArray2.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Monitoring Flag"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (
        get(currentFilter, "displayName", "NA") === "Recipient State"
      ) {
        // if(searchedFilterList.length==filteredArray1.length){
        //   this.setState({selectall:true})
        // }
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray1.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Recipient State"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (
        get(currentFilter, "displayName", "NA") === "Recipient Ministry"
      ) {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          // console.log("ID found:", idFound);
        } else {
          filteredArray3.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Recipient Ministry"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Issue Location") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          // console.log("ID found:", idFound);
        } else {
          filteredArray4.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Issue Location"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Issue Stages") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray5.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Issue Stages"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Issue Category") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray6.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Issue Category"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (
        get(currentFilter, "displayName", "NA") === "Issue Sponsoring Ministry"
      ) {
        // if(searchedFilterList.length==filteredArray7.length){
        //   this.setState({selectall:true})
        // }
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray7.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Issue Sponsoring Ministry"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Project Status") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          let projectstatusids = searchedFilterList.filter(
            user =>
              user.key !== "NO_COMPLETION_STAGE" &&
              user.key !== "NO_IMPLEMENTATION"
          );
          filteredArray8.map(itemFromFilteredArray1 => {
            const matchingIndex = projectstatusids.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Project Status"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Project Stage") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray9.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(
              matchingIndex,
              "Project Stage"
            );
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      } else if (get(currentFilter, "displayName", "NA") === "Zone") {
        const hasId = searchedFilterList.some(element =>
          element.hasOwnProperty("id")
        );
        // If there's an ID, find and return it
        if (hasId) {
          const idFound = searchedFilterList
            .filter(element => element.hasOwnProperty("id"))
            .map(element => element.id);
          //console.log("ID found:", idFound);
        } else {
          filteredArray10.map(itemFromFilteredArray1 => {
            const matchingIndex = searchedFilterList.findIndex(
              itemFromSearchedFilterList =>
                itemFromSearchedFilterList.displayName ===
                itemFromFilteredArray1.displayName
            );
            itemFromFilteredArray1["id"] = this.randId(matchingIndex, "Zone");
            checkedFiltersids.add(itemFromFilteredArray1.id);
          });
        }
      }
    });
    if (checkedData.length == []) {
      this.setState({ propsCheckedData: [], issueFilterID: [] });
      //console.log("true")
    } else {
      this.setState({ propsCheckedData: Array.from(checkedFiltersids) }, () => {
        //console.log(this.state.propsCheckedData)
      });
    }
  };
  handleClose = () => {
    this.setState({ model_open: false });
  };
  handlecheckboxcount(e, displayName, filter, searchedFilterList, id) {
    if (e.target.checked) {
      //filter.checked=true
      // filter["id"] = id;

      const newItems2 = [...this.state.issueFilterID];
      newItems2.push(filter.id);
      this.setState({ issueFilterID: newItems2 }, () => {
        //console.log(this.state.issueFilterID)
      });

      if (this.state.quickfilterdata.includes("Monitoring Flag")) {
        this.setState(
          { MonitoringFlag: this.state.MonitoringFlag.concat([filter]) },
          () => {
            if (
              this.state.projectFlagsFilterdata.length ==
              this.state.MonitoringFlag.length
            ) {
              //console.log("true")
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Project Status")) {
        this.setState(
          { ProjectStatus: this.state.ProjectStatus.concat([filter]) },
          () => {
            if (
              this.state.projectTagsFilterdata.length ==
              this.state.ProjectStatus.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Project Stage")) {
        this.setState(
          { ProjectStage: this.state.ProjectStage.concat([filter]) },
          () => {
            if (
              this.state.projectStageFilterdata.length ==
              this.state.ProjectStage.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Recipient State")) {
        this.setState(
          { RecipientState: this.state.RecipientState.concat([filter]) },
          () => {
            if (
              this.state.recipientStateFilterdata.length ==
              this.state.RecipientState.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Zone")) {
        this.setState(
          { IssueZone: this.state.IssueZone.concat([filter]) },
          () => {
            if (
              this.state.issueZoneFilterdata.length ==
              this.state.IssueZone.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Recipient Ministry")) {
        this.setState(
          { RecipientMinistry: this.state.RecipientMinistry.concat([filter]) },
          () => {
            if (
              this.state.recipientCenterFilterdata.length ==
              this.state.RecipientMinistry.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Issue Location")) {
        this.setState(
          { IssueLocation: this.state.IssueLocation.concat([filter]) },
          () => {
            if (
              this.state.centerStateFilterdata.length ==
              this.state.IssueLocation.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Issue Stages")) {
        this.setState(
          { IssueStages: this.state.IssueStages.concat([filter]) },
          () => {
            if (
              this.state.stagesFilterdata.length ==
              this.state.IssueStages.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Issue Category")) {
        this.setState(
          { IssueCategory: this.state.IssueCategory.concat([filter]) },
          () => {
            if (
              this.state.categoryFilterdata.length ==
              this.state.IssueCategory.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
      if (this.state.quickfilterdata.includes("Issue Sponsoring Ministry")) {
        this.setState(
          {
            IssueSponsoringMinistry: this.state.IssueSponsoringMinistry.concat([
              filter
            ])
          },
          () => {
            if (
              this.state.sponsoringMinistryFilterdata.length ==
              this.state.IssueSponsoringMinistry.length
            ) {
              this.setState({ selectall: true });
            }
          }
        );
      }
    } else {
      this.setState(
        {
          selectall: false,
          StaticCheckboxData: this.state.StaticCheckboxData.filter(function(
            val
          ) {
            return val !== filter.displayName;
          }),
          propsCheckedData: this.state.propsCheckedData.filter(function(val) {
            return val !== filter.id;
          }),
          issueFilterID: this.state.issueFilterID.filter(function(val) {
            return val !== filter.id;
          })
        },
        () => {
          //console.log(this.state.issueFilterID)
        }
      );
      //filter.checked=false
      if (this.state.quickfilterdata.includes("Monitoring Flag")) {
        //console.log(this.state.MonitoringFlag)
        this.setState(
          {
            MonitoringFlag: this.state.MonitoringFlag.filter(function(val) {
              return val.displayName !== filter.displayName;
            })
          },
          () => {
            //console.log(this.state.MonitoringFlag)
          }
        );
      }
      if (this.state.quickfilterdata.includes("Project Status")) {
        this.setState({
          ProjectStatus: this.state.ProjectStatus.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Project Stage")) {
        this.setState({
          ProjectStage: this.state.ProjectStage.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Recipient State")) {
        this.setState({
          RecipientState: this.state.RecipientState.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Recipient Ministry")) {
        this.setState({
          RecipientMinistry: this.state.RecipientMinistry.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Zone")) {
        this.setState({
          IssueZone: this.state.IssueZone.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Issue Location")) {
        this.setState({
          IssueLocation: this.state.IssueLocation.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Issue Stages")) {
        this.setState({
          IssueStages: this.state.IssueStages.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Issue Category")) {
        this.setState({
          IssueCategory: this.state.IssueCategory.filter(function(val) {
            return val.displayName !== filter.displayName;
          })
        });
      }
      if (this.state.quickfilterdata.includes("Issue Sponsoring Ministry")) {
        this.setState({
          IssueSponsoringMinistry: this.state.IssueSponsoringMinistry.filter(
            function(val) {
              return val.displayName !== filter.displayName;
            }
          )
        });
      }
    }
  }

  randId = (index, displayName) => {
    return `ID-${index + 1}-${displayName}`;
  };
  handleSelectAll(e, searchedFilterList, displayname) {
    if (e.target.checked) {
      //var newArr = searchedFilterList.map((item) => item.displayName);
      if (this.state.quickfilterdata.includes("Monitoring Flag")) {
        var allelement = this.state.projectFlagsFilterdata.map(
          (item, index) => {
            item.checked = true;

            return item;
          }
        );
        var allelementid = this.state.projectFlagsFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Recipient State")) {
        var allelement = this.state.recipientStateFilterdata.map(
          (item, index) => {
            item.checked = true;
            //item["id"] = this.randId(index,displayname);
            return item;
          }
        );
        var allelementid = this.state.recipientStateFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Recipient Ministry")) {
        var allelement = this.state.recipientCenterFilterdata.map(
          (item, index) => {
            item.checked = true;
            // item["id"] = this.randId(index,displayname);
            return item;
          }
        );
        var allelementid = this.state.recipientCenterFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Issue Location")) {
        var allelement = this.state.centerStateFilterdata.map((item, index) => {
          item.checked = true;
          // item["id"] = this.randId(index,displayname);
          return item;
        });
        var allelementid = this.state.centerStateFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Issue Stages")) {
        var allelement = this.state.stagesFilterdata.map((item, index) => {
          item.checked = true;
          //item["id"] = this.randId(index,displayname);
          return item;
        });
        var allelementid = this.state.stagesFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Issue Category")) {
        var allelement = this.state.categoryFilterdata.map((item, index) => {
          item.checked = true;
          //item["id"] = this.randId(index,displayname);
          return item;
        });
        var allelementid = this.state.categoryFilterdata.map(item => {
          return item.id;
        });
      } else if (
        this.state.quickfilterdata.includes("Issue Sponsoring Ministry")
      ) {
        var allelement = this.state.sponsoringMinistryFilterdata.map(
          (item, index) => {
            item.checked = true;
            //item["id"] = this.randId(index,displayname);
            return item;
          }
        );
        var allelementid = this.state.sponsoringMinistryFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Project Status")) {
        var allelement = this.state.projectTagsFilterdata.map((item, index) => {
          item.checked = true;
          //item["id"] = this.randId(index,displayname);
          return item;
        });
        var allelementid = this.state.projectTagsFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Project Stage")) {
        var allelement = this.state.projectStageFilterdata.map(
          (item, index) => {
            item.checked = true;
            //item["id"] = this.randId(index,displayname);
            return item;
          }
        );
        var allelementid = this.state.projectStageFilterdata.map(item => {
          return item.id;
        });
      } else if (this.state.quickfilterdata.includes("Zone")) {
        var allelement = this.state.issueZoneFilterdata.map((item, index) => {
          item.checked = true;
          //item["id"] = this.randId(index,displayname);
          return item;
        });
        var allelementid = this.state.issueZoneFilterdata.map(item => {
          return item.id;
        });
      }

      const newItems1 = [...this.state.issueFilterID];
      newItems1.push(...allelementid);

      this.setState({ issueFilterID: newItems1 }, () => {
        // console.log(this.state.issueFilterID);
      });

      if (displayname == "Monitoring Flag") {
        this.setState({ MonitoringFlag: allelement });
      }
      if (displayname == "Project Status") {
        let usersWithoutTim = allelement.filter(
          user =>
            user.key !== "NO_COMPLETION_STAGE" &&
            user.key !== "NO_IMPLEMENTATION"
        );
        this.setState({ ProjectStatus: usersWithoutTim });
      }
      if (displayname == "Project Stage") {
        this.setState({ ProjectStage: allelement });
      }
      if (displayname == "Recipient State") {
        this.setState({ RecipientState: allelement });
      }
      if (displayname == "Recipient Ministry") {
        this.setState({ RecipientMinistry: allelement });

        this.setState({ StaticCheckboxData: newItems1 });
      }
      if (displayname == "Zone") {
        this.setState({ IssueZone: allelement });
      }
      if (displayname == "Issue Location") {
        this.setState({ IssueLocation: allelement });
      }
      if (displayname == "Issue Stages") {
        this.setState({ IssueStages: allelement });
      }
      if (displayname == "Issue Category") {
        this.setState({ IssueCategory: allelement });
      }
      if (displayname == "Issue Sponsoring Ministry") {
        this.setState({ IssueSponsoringMinistry: allelement });
      }
      this.setState({ selectall: true });
    } else {
      this.setState({ selectall: false, propsCheckedData: [] });
      if (displayname == "Monitoring Flag") {
        const secondArrayKeys = new Set(
          this.state.MonitoringFlag.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, MonitoringFlag: [] });
      }
      if (displayname == "Project Status") {
        const secondArrayKeys = new Set(
          this.state.ProjectStatus.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, ProjectStatus: [] });
      }
      if (displayname == "Project Stage") {
        const secondArrayKeys = new Set(
          this.state.ProjectStage.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, ProjectStage: [] });
      }
      if (displayname == "Recipient State") {
        const secondArrayKeys = new Set(
          this.state.RecipientState.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, RecipientState: [] });
      }
      if (displayname == "Recipient Ministry") {
        const secondArrayKeys = new Set(
          this.state.RecipientMinistry.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          issueFilterID: updatedFirstArray,
          RecipientMinistry: []
        });
      }
      if (displayname == "Zone") {
        const secondArrayKeys = new Set(
          this.state.IssueZone.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, IssueZone: [] });
      }
      if (displayname == "Issue Location") {
        const secondArrayKeys = new Set(
          this.state.IssueLocation.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, IssueLocation: [] });
      }
      if (displayname == "Issue Stages") {
        const secondArrayKeys = new Set(
          this.state.IssueStages.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, IssueStages: [] });
      }
      if (displayname == "Issue Category") {
        const secondArrayKeys = new Set(
          this.state.IssueCategory.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({ issueFilterID: updatedFirstArray, IssueCategory: [] });
      }
      if (displayname == "Issue Sponsoring Ministry") {
        const secondArrayKeys = new Set(
          this.state.IssueSponsoringMinistry.map(obj => obj.id)
        );
        const updatedFirstArray = this.state.issueFilterID.filter(
          element => !secondArrayKeys.has(element)
        );
        this.setState({
          issueFilterID: updatedFirstArray,
          IssueSponsoringMinistry: []
        });
      }
    }
  }

  getFilterBySearch = (search, filterName) => {
    const { onChange } = this.props;
    isFunction(onChange) && onChange(search.searchedText, filterName);
  };

  getSearchedFilters = (filterList = [], searchText = "") => {
    return filterList.filter(item => {
      if (searchText === "") return true;
      else {
        const regex = new RegExp(searchText, "ig");
        return regex.test(item.displayName);
      }
    });
  };

  searchDocument = (e, displayName, searchedFilterList) => {
    const newList = searchedFilterList.map((filter, index) => {
      return { ...filter, id: this.randId(index, displayName) };
    });
    searchedFilterList.splice(0, searchedFilterList.length, ...newList);
    const searchAndFilter = searchText => {
      return newList.filter(item => {
        // Search within both 'key' and 'displayName' fields
        const lowerCaseSearchText = searchText.toLowerCase();
        const itemKeyLower = item.key.toLowerCase();
        const itemDisplayNameLower = item.displayName.toLowerCase();

        return (
          itemKeyLower.includes(lowerCaseSearchText) ||
          itemDisplayNameLower.includes(lowerCaseSearchText)
        );
      });
    };

    this.setState({ searchedtext: e.target.value });
    const filteredArray = searchAndFilter(e.target.value.trim());
    if (displayName == "Monitoring Flag") {
      this.setState({ projectFlagsFilterdata: filteredArray }, () => {
        if (this.state.projectFlagsFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Recipient State") {
      this.setState({ recipientStateFilterdata: filteredArray }, () => {
        if (this.state.recipientStateFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Recipient Ministry") {
      this.setState({ recipientCenterFilterdata: filteredArray }, () => {
        if (this.state.recipientCenterFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Issue Location") {
      this.setState({ centerStateFilterdata: filteredArray }, () => {
        if (this.state.centerStateFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Issue Stages") {
      this.setState({ stagesFilterdata: filteredArray }, () => {
        if (this.state.stagesFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Issue Category") {
      this.setState({ categoryFilterdata: filteredArray }, () => {
        if (this.state.categoryFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Issue Sponsoring Ministry") {
      this.setState({ sponsoringMinistryFilterdata: filteredArray }, () => {
        if (this.state.sponsoringMinistryFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Project Status") {
      this.setState({ projectTagsFilterdata: filteredArray }, () => {
        if (this.state.projectTagsFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Project Stage") {
      this.setState({ projectStageFilterdata: filteredArray }, () => {
        if (this.state.projectStageFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    } else if (displayName == "Zone") {
      this.setState({ issueZoneFilterdata: filteredArray }, () => {
        if (this.state.issueZoneFilterdata.length == 0) {
          this.setState({ selectalltext: false });
        } else {
          this.setState({ selectalltext: true });
        }
      });
    }
  };
  handleFiltertext = (e, displayname, searchedFilterList) => {
    //console.log(this.state.issueZoneFilterdata);
    const newItems = [...this.state.quickfilterdata];
    newItems[0] = displayname;
    this.setState({
      quickfilterdata: newItems,
      selectall: false,
      projectFlagsEmpty: false,
      recipientStateEmpty: false,
      recipientCenterEmpty: false,
      centerStateEmpty: false,
      stagesFilterdataEmpty: false,
      categoryFilterdataEmpty: false,
      sponsoringMinistryEmpty: false,
      projectTagsEmpty: false,
      projectStageEmpty: false,
      issuesZoneEmpty: false
    });
    const newItems1 = [...this.state.quickfilterdatanew];
    newItems1.push(displayname);
    this.setState({ quickfilterdatanew: newItems1, searchedtext: "" });
    const { filterData, AgendaIssueStage } = this.props;
    if (
      this.state.projectFlagsFilterdata.length == 0 &&
      displayname == "Monitoring Flag"
    ) {
      //console.log(this.state.projectFlagsFilterdata)
      this.setState({
        projectFlagsEmpty: true,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.recipientStateFilterdata.length == 0 &&
      displayname == "Recipient State"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: true,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.recipientCenterFilterdata.length == 0 &&
      displayname == "Recipient Ministry"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: true,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.centerStateFilterdata.length == 0 &&
      displayname == "Issue Location"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: true,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.stagesFilterdata.length == 0 &&
      displayname == "Issue Stages"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: true,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.categoryFilterdata.length == 0 &&
      displayname == "Issue Category"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: true,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.sponsoringMinistryFilterdata.length == 0 &&
      displayname == "Issue Sponsoring Ministry"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: true,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.projectTagsFilterdata.length == 0 &&
      displayname == "Project Status"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: true,
        projectStageEmpty: false,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.projectStageFilterdata.length == 0 &&
      displayname == "Project Stage"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: true,
        issuesZoneEmpty: false
      });
    } else if (
      this.state.issueZoneFilterdata.length == 0 &&
      displayname == "Zone"
    ) {
      this.setState({
        projectFlagsEmpty: false,
        recipientStateEmpty: false,
        recipientCenterEmpty: false,
        centerStateEmpty: false,
        stagesFilterdataEmpty: false,
        categoryFilterdataEmpty: false,
        sponsoringMinistryEmpty: false,
        projectTagsEmpty: false,
        projectStageEmpty: false,
        issuesZoneEmpty: true
      });
    }
    if (this.state.quickfilterdata.includes("Monitoring Flag")) {
      const updatedArray1 = filterData.projectFlags.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Monitoring Flag") // Generate unique IDs using index
        })
      );
      this.setState({
        projectFlagsFilterdata: updatedArray1,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Zone")) {
      const updatedArray5 = filterData.issueZones.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Zone") // Generate unique IDs using index
      }));
      if (searchedFilterList.length == this.state.IssueZone.length) {
        this.setState({ selectall: true });
      }
      this.setState({
        issueZoneFilterdata: updatedArray5,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Recipient State")) {
      const updatedArray2 = filterData.recipientState.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Recipient State") // Generate unique IDs using index
        })
      );
      this.setState({
        recipientStateFilterdata: updatedArray2,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Recipient Ministry")) {
      const updatedArray3 = filterData.recipientCenter.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Recipient Ministry") // Generate unique IDs using index
        })
      );
      this.setState({
        recipientCenterFilterdata: updatedArray3,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Issue Location")) {
      const updatedArray4 = filterData.centerState.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Location") // Generate unique IDs using index
      }));
      this.setState({
        centerStateFilterdata: updatedArray4,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Issue Stages")) {
      if (AgendaIssueStage == true) {
        const targetNames = [
          "Pending with PMG",
          "Pending with RM/RS",
          "Pending with SM",
          "Under PMG Decision"
        ];
        const updatedArray5 = filterData.stages.values.map((obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Stages") // Generate unique IDs using index
        }));
        const filteredArray = updatedArray5.filter(item => {
          return targetNames.includes(item.displayName);
        });
        this.setState({ stagesFilterdata: filteredArray, selectalltext: true });
      } else {
        const updatedArray5 = filterData.stages.values.map((obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Stages") // Generate unique IDs using index
        }));
        this.setState({ stagesFilterdata: updatedArray5, selectalltext: true });
      }
    } else if (this.state.quickfilterdata.includes("Issue Category")) {
      const updatedArray6 = filterData.category.values.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Issue Category") // Generate unique IDs using index
      }));
      this.setState({ categoryFilterdata: updatedArray6, selectalltext: true });
    } else if (
      this.state.quickfilterdata.includes("Issue Sponsoring Ministry")
    ) {
      const updatedArray7 = filterData.sponsoringMinistry.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Issue Sponsoring Ministry") // Generate unique IDs using index
        })
      );
      this.setState({
        sponsoringMinistryFilterdata: updatedArray7,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Status")) {
      let usersWithoutTim = filterData.projectStatus.values.filter(
        user =>
          user.key !== "NO_COMPLETION_STAGE" && user.key !== "NO_IMPLEMENTATION"
      );
      const updatedArray8 = usersWithoutTim.map((obj, index) => ({
        ...obj,
        id: this.randId(index, "Project Status") // Generate unique IDs using index
      }));
      this.setState({
        projectTagsFilterdata: updatedArray8,
        selectalltext: true
      });
    } else if (this.state.quickfilterdata.includes("Project Stage")) {
      const updatedArray9 = filterData.projectStage.values.map(
        (obj, index) => ({
          ...obj,
          id: this.randId(index, "Project Stage") // Generate unique IDs using index
        })
      );
      this.setState({
        projectStageFilterdata: updatedArray9,
        selectalltext: true
      });
    } else {
    }
    var newArr = searchedFilterList.map(item => item.displayName);
    var newArr1 = newArr.filter(
      user => user !== "NO_COMPLETION_STAGE" && user !== "NO_IMPLEMENTATION"
    );
    const issuestagestargetNames = [
      "Pending with PMG",
      "Pending with RM/RS",
      "Pending with SM",
      "Under PMG Decision"
    ];
    const issuestagestargetNamesfilteredArray = newArr.filter(item => {
      return issuestagestargetNames.includes(item);
    });
    if (
      this.state.ProjectStatus.length ==
        this.state.projectTagsFilterdata.length &&
      displayname == "Project Status"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.MonitoringFlag.length ==
        this.state.projectFlagsFilterdata.length &&
      displayname == "Monitoring Flag"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.ProjectStage.length ==
        this.state.projectStageFilterdata.length &&
      displayname == "Project Stage"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.RecipientState.length ==
        this.state.recipientStateFilterdata.length &&
      displayname == "Recipient State"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.RecipientMinistry.length ==
        this.state.recipientCenterFilterdata.length &&
      displayname == "Recipient Ministry"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.IssueZone.length == this.state.issueZoneFilterdata.length &&
      displayname == "Zone"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.IssueLocation.length ==
        this.state.centerStateFilterdata.length &&
      displayname == "Issue Location"
    ) {
      this.setState({ selectall: true });
    } else if (
      AgendaIssueStage &&
      (this.state.IssueStages.length ==
        issuestagestargetNamesfilteredArray.length &&
        displayname == "Issue Stages")
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.IssueStages.length == this.state.stagesFilterdata.length &&
      displayname == "Issue Stages"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.IssueCategory.length == this.state.categoryFilterdata.length &&
      displayname == "Issue Category"
    ) {
      this.setState({ selectall: true });
    } else if (
      this.state.IssueSponsoringMinistry.length ==
        this.state.sponsoringMinistryFilterdata.length &&
      displayname == "Issue Sponsoring Ministry"
    ) {
      this.setState({ selectall: true });
    } else {
      this.setState({ selectall: false });
    }
  };
  getStateFilterVal = _filterName => {
    const {
      projectSponsoringMinistry,
      projectSector,
      recipientMinistryState,
      recipientState,
      issueSponsoringMinistry,
      recipientMinistry,
      recipientStateDepartment,
      guests,
      projectProponent,
      proponent,
      milestone,
      sponsoringDepartment,
      projectTags,
      projectStatus,
      projectLocation,
      centerState,
      projectFlags,
      projectstage,
      impmode,
      category,
      stages
    } = this.state;

    switch (_filterName) {
      case "projectSponsoringMinistry":
        return projectSponsoringMinistry;
      case "projectFlags":
        return projectFlags;

      case "projectstage":
        return projectstage;
      case "impmode":
        return impmode;
      case "projectSector":
        return projectSector;
      case "recipientMinistryState":
        return recipientMinistryState;
      case "stages":
        return stages;
      case "category":
        return category;
      case "recipientState":
        return recipientState;
      case "issueSponsoringMinistry":
        return issueSponsoringMinistry;
      case "recipientMinistry":
        return recipientMinistry;
      case "recipientStateDepartment":
        return recipientStateDepartment;
      case "guests":
        return guests;
      case "projectProponent":
        return projectProponent;
      case "proponent":
        return proponent;
      case "milestone":
        return milestone;
      case "sponsoringDepartment":
        return sponsoringDepartment;
      case "projectTags":
        return projectTags;
      case "projectStatus":
        return projectStatus;
      case "projectLocation":
        return projectLocation;
      case "centerState":
        return centerState;
      default:
        return "";
    }
  };

  placeCheckedFiltersOnTop(filterValues) {
    let sortedFilterValues = [];

    for (let i = 0; i < filterValues.length; i++) {
      if (filterValues[i].checked === false) {
        sortedFilterValues.push(filterValues[i]);
      } else {
        sortedFilterValues.unshift(filterValues[i]);
      }
    }
    return sortedFilterValues;
  }

  render() {
    //const { onChange } = this.props;
    const {
      filterData,
      clearAll,
      filtersValue,
      staticFilterData,
      AgendaIssueStage
    } = this.props;
    const filtersKeysArr = Object.keys(staticFilterData || {});
    // const minLengthForSearch = 5;
    if (!filtersKeysArr.length) {
      return null;
    }
    const user = getLocalstorage("user");
    if (
      get(user, "groupCategory") == "STATE" ||
      get(user, "groupCategory") == "CENTRAL_DEPARTMENT" ||
      get(user, "groupCategory") == "CENTRAL"
    ) {
      filterData.agendaStages = {};
    }
    return (
      isValidArray(filtersKeysArr) && (
        <React.Fragment className="row">
          <OverlayTrigger
            trigger="hover"
            defaultShow={false}
            placement="bottom"
            overlay={
              <Tooltip id={`tooltip-checking`} className="quick_filter_tolltip">
                Quick Filters
              </Tooltip>
            }
          >
            <div className="filter-title">
              <Image
                src={QuickFilterIcon}
                onClick={this.handleOpen}
                alt="Filter Icon"
                style={{ cursor: "pointer" }}
              />
            </div>
          </OverlayTrigger>
          <Modal
            size="lg"
            show={this.state.model_open}
            onHide={this.handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
            className="content-modal"
          >
            <div
              className="modal-box-shadow"
              style={{
                width: "111%",
                background: "white",
                marginLeft: "-4%",
                borderRadius: "0.3rem"
              }}
            >
              <Modal.Header
                closeButton
                className="header-modal"
                style={{ backgroundColor: "#E7EFFB" }}
              >
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{
                    paddingLeft: "4%",
                    paddingTop: "1.5%",
                    paddingBottom: "1.5%"
                  }}
                >
                  Quick Filters
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{ padding: "0%" }}
                className="quick-filter-modal-body"
              >
                <div className="row">
                  <div
                    className="col-md-5 quickfilterbox"
                    style={{ maxWidth: "37%" }}
                  >
                    {isValidArray(filtersKeysArr)
                      ? filtersKeysArr.map(filterName => {
                          const currentFilter = staticFilterData[filterName];
                          if (currentFilter && currentFilter.values) {
                            currentFilter.values = this.placeCheckedFiltersOnTop(
                              currentFilter.values
                            );
                          }
                          const filterCurrentValue = filtersValue[filterName];
                          const _filterName =
                            filterNames[get(currentFilter, "displayName")];
                          let searchedFilterList = this.getSearchedFilters(
                            get(currentFilter, "values"),
                            this.getStateFilterVal(_filterName)
                          );

                          // const searchResult = sortedListingArr[filterName];
                          if (!isValidArray(get(currentFilter, "values"))) {
                            return null;
                          }
                          let usersWithoutTim = searchedFilterList.filter(
                            user =>
                              user.key !== "NO_COMPLETION_STAGE" &&
                              user.key !== "NO_IMPLEMENTATION"
                          );
                          return (
                            <div
                              key={filterName}
                              style={{
                                display:
                                  get(currentFilter, "displayName", "NA") ==
                                    "Monitoring Flag" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Recipient State" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Recipient Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Zone" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Location" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Stages" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Category" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Sponsoring Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Status" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Stage"
                                    ? null
                                    : "none",
                                marginBottom: "0rem",
                                borderBottom:
                                  get(currentFilter, "displayName", "NA") ==
                                  "Project Stage"
                                    ? "none"
                                    : "1.5px solid rgb(210, 210, 210)",
                                backgroundColor: this.state.quickfilterdata.includes(
                                  get(currentFilter, "displayName", "NA")
                                )
                                  ? "white"
                                  : "#F4F8FC",
                                padding: "7%"
                              }}
                              className="quick-filter-text-project"
                              onClick={e =>
                                this.handleFiltertext(
                                  e,
                                  currentFilter.displayName,
                                  searchedFilterList
                                )
                              }
                            >
                              <div
                                data-test={get(
                                  currentFilter,
                                  "displayName",
                                  "NA"
                                ).replace(" ", "-")}
                                style={{
                                  marginLeft: "6%"
                                }}
                              >
                                {get(currentFilter, "displayName", "NA")}
                                &nbsp;
                                {get(currentFilter, "displayName", "NA") ==
                                  "Monitoring Flag" &&
                                this.state.MonitoringFlag.length != 0 ? (
                                  <>({this.state.MonitoringFlag.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Status" &&
                                this.state.ProjectStatus.length != 0 ? (
                                  <>({this.state.ProjectStatus.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Project Stage" &&
                                this.state.ProjectStage.length != 0 ? (
                                  <>({this.state.ProjectStage.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Recipient State" &&
                                this.state.RecipientState.length != 0 ? (
                                  <>({this.state.RecipientState.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Zone" && this.state.IssueZone.length != 0 ? (
                                  <>({this.state.IssueZone.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Issue Location" &&
                                this.state.IssueLocation.length != 0 ? (
                                  <>({this.state.IssueLocation.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Recipient Ministry" &&
                                this.state.RecipientMinistry.length != 0 ? (
                                  <>({this.state.RecipientMinistry.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Issue Stages" &&
                                this.state.IssueStages.length != 0 ? (
                                  <>({this.state.IssueStages.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Issue Category" &&
                                this.state.IssueCategory.length != 0 ? (
                                  <>({this.state.IssueCategory.length})</>
                                ) : null}
                                {get(currentFilter, "displayName", "NA") ==
                                  "Issue Sponsoring Ministry" &&
                                this.state.IssueSponsoringMinistry.length !=
                                  0 ? (
                                  <>
                                    ({this.state.IssueSponsoringMinistry.length}
                                    )
                                  </>
                                ) : null}
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div
                    className="col-md-8"
                    style={{
                      display:
                        this.state.projectFlagsEmpty ||
                        this.state.recipientStateEmpty ||
                        this.state.recipientCenterEmpty ||
                        this.state.centerStateEmpty ||
                        this.state.stagesFilterdataEmpty ||
                        this.state.categoryFilterdataEmpty ||
                        this.state.sponsoringMinistryEmpty ||
                        this.state.projectTagsEmpty ||
                        this.state.projectStageEmpty ||
                        this.state.issuesZoneEmpty
                          ? null
                          : "none",
                      marginTop: "-1em",
                      maxWidth: "63%"
                    }}
                  >
                    <NoDataFound />
                  </div>
                  <div
                    className="col-md-8"
                    style={{
                      maxWidth:
                        this.state.projectFlagsEmpty ||
                        this.state.recipientStateEmpty ||
                        this.state.recipientCenterEmpty ||
                        this.state.centerStateEmpty ||
                        this.state.stagesFilterdataEmpty ||
                        this.state.categoryFilterdataEmpty ||
                        this.state.sponsoringMinistryEmpty ||
                        this.state.projectTagsEmpty ||
                        this.state.issuesZoneEmpty ||
                        this.state.projectStageEmpty
                          ? null
                          : "60%",
                      marginLeft:
                        this.state.projectFlagsEmpty ||
                        this.state.recipientStateEmpty ||
                        this.state.recipientCenterEmpty ||
                        this.state.centerStateEmpty ||
                        this.state.stagesFilterdataEmpty ||
                        this.state.categoryFilterdataEmpty ||
                        this.state.sponsoringMinistryEmpty ||
                        this.state.projectTagsEmpty ||
                        this.state.issuesZoneEmpty ||
                        this.state.projectStageEmpty
                          ? null
                          : "-1%",
                      paddingTop:
                        this.state.projectFlagsEmpty ||
                        this.state.recipientStateEmpty ||
                        this.state.recipientCenterEmpty ||
                        this.state.centerStateEmpty ||
                        this.state.stagesFilterdataEmpty ||
                        this.state.categoryFilterdataEmpty ||
                        this.state.sponsoringMinistryEmpty ||
                        this.state.projectTagsEmpty ||
                        this.state.issuesZoneEmpty ||
                        this.state.projectStageEmpty
                          ? null
                          : "2%"
                    }}
                  >
                    {isValidArray(filtersKeysArr)
                      ? filtersKeysArr.map(filterName => {
                          const currentFilter = filterData[filterName];
                          if (currentFilter && currentFilter.values) {
                            currentFilter.values = this.placeCheckedFiltersOnTop(
                              currentFilter.values
                            );
                          }
                          const filterCurrentValue = filtersValue[filterName];
                          const _filterName =
                            filterNames[get(currentFilter, "displayName")];
                          let searchedFilterList = this.getSearchedFilters(
                            get(currentFilter, "values"),
                            this.getStateFilterVal(_filterName)
                          );

                          // const searchResult = sortedListingArr[filterName];
                          if (!isValidArray(get(currentFilter, "values"))) {
                            return null;
                          }

                          let usersWithoutTim = searchedFilterList.filter(
                            user =>
                              user.key !== "NO_COMPLETION_STAGE" &&
                              user.key !== "NO_IMPLEMENTATION"
                          );
                          return (
                            <div
                              key={filterName}
                              style={{
                                display:
                                  get(currentFilter, "displayName", "NA") ==
                                    "Monitoring Flag" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Recipient State" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Recipient Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Zone" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Location" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Stages" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Category" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Issue Sponsoring Ministry" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Status" ||
                                  get(currentFilter, "displayName", "NA") ==
                                    "Project Stage"
                                    ? null
                                    : "none",
                                marginBottom: "0rem"
                              }}
                            >
                              <div
                                style={{
                                  display:
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Monitoring Flag" &&
                                      this.state.quickfilterdata.includes(
                                        "Monitoring Flag"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Recipient State" &&
                                      this.state.quickfilterdata.includes(
                                        "Recipient State"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Recipient Ministry" &&
                                      this.state.quickfilterdata.includes(
                                        "Recipient Ministry"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Issue Location" &&
                                      this.state.quickfilterdata.includes(
                                        "Issue Location"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Issue Stages" &&
                                      this.state.quickfilterdata.includes(
                                        "Issue Stages"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Issue Category" &&
                                      this.state.quickfilterdata.includes(
                                        "Issue Category"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Issue Sponsoring Ministry" &&
                                      this.state.quickfilterdata.includes(
                                        "Issue Sponsoring Ministry"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Status" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Status"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Project Stage" &&
                                      this.state.quickfilterdata.includes(
                                        "Project Stage"
                                      )) ||
                                    (get(currentFilter, "displayName", "NA") ==
                                      "Zone" &&
                                      this.state.quickfilterdata.includes(
                                        "Zone"
                                      ))
                                      ? null
                                      : "none",
                                  marginBottom: "0rem"
                                }}
                              >
                                <div
                                  className="search-container-component-new"
                                  style={{
                                    display:
                                      this.state.projectFlagsEmpty ||
                                      this.state.recipientStateEmpty ||
                                      this.state.recipientCenterEmpty ||
                                      this.state.centerStateEmpty ||
                                      this.state.stagesFilterdataEmpty ||
                                      this.state.categoryFilterdataEmpty ||
                                      this.state.sponsoringMinistryEmpty ||
                                      this.state.projectTagsEmpty ||
                                      this.state.projectStageEmpty ||
                                      this.state.issuesZoneEmpty
                                        ? "none"
                                        : null
                                  }}
                                >
                                  <Form.Control
                                    placeholder="Search"
                                    type="text"
                                    className="search-field"
                                    onChange={e =>
                                      this.searchDocument(
                                        e,
                                        currentFilter.displayName,
                                        searchedFilterList
                                      )
                                    }
                                    value={this.state.searchedtext}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "-6%",
                                      cursor: "pointer",
                                      display:
                                        this.state.searchedtext == ""
                                          ? "none"
                                          : null
                                    }}
                                  >
                                    <img
                                      src={CrossIcon}
                                      alt="Clear search"
                                      onClick={() =>
                                        this.handleCross(searchedFilterList)
                                      }
                                    />
                                  </span>
                                  {<span className="search-container-icon" />}
                                </div>

                                <div
                                  className="row"
                                  style={{
                                    padding: "1.5%",
                                    marginLeft: "0.9%",
                                    marginBottom: "-5%"
                                  }}
                                >
                                  <div
                                    className="col-12"
                                    style={{
                                      display:
                                        this.state.projectFlagsEmpty ||
                                        this.state.recipientStateEmpty ||
                                        this.state.recipientCenterEmpty ||
                                        this.state.centerStateEmpty ||
                                        this.state.stagesFilterdataEmpty ||
                                        this.state.categoryFilterdataEmpty ||
                                        this.state.sponsoringMinistryEmpty ||
                                        this.state.projectTagsEmpty ||
                                        this.state.projectStageEmpty ||
                                        this.state.issuesZoneEmpty
                                          ? "none"
                                          : null
                                    }}
                                  >
                                    <div
                                      style={{
                                        display:
                                          this.state.selectalltext == false
                                            ? "none"
                                            : null
                                      }}
                                    >
                                      <label class="container1">
                                        <input
                                          type="checkbox"
                                          id={get(currentFilter, "displayName")}
                                          checked={
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.MonitoringFlag
                                                  .length ||
                                                this.state
                                                  .projectFlagsFilterdata
                                                  .length ==
                                                  this.state.MonitoringFlag
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectStatus
                                                  .length ||
                                                this.state.projectTagsFilterdata
                                                  .length ==
                                                  this.state.ProjectStatus
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.ProjectStage
                                                  .length ||
                                                this.state
                                                  .projectStageFilterdata
                                                  .length ==
                                                  this.state.ProjectStage
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.RecipientState
                                                  .length ||
                                                this.state
                                                  .recipientStateFilterdata
                                                  .length ==
                                                  this.state.RecipientState
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.RecipientMinistry
                                                  .length ||
                                                this.state
                                                  .recipientCenterFilterdata
                                                  .length ==
                                                  this.state.RecipientMinistry
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.IssueZone.length ||
                                                this.state.issueZoneFilterdata
                                                  .length ==
                                                  this.state.IssueZone
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.IssueLocation
                                                  .length ||
                                                this.state.centerStateFilterdata
                                                  .length ==
                                                  this.state.IssueLocation
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.IssueStages.length ||
                                                this.state.stagesFilterdata
                                                  .length ==
                                                  this.state.IssueStages
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state.IssueCategory
                                                  .length ||
                                                this.state.categoryFilterdata
                                                  .length ==
                                                  this.state.IssueCategory
                                                    .length)) ||
                                            (this.state.selectall &&
                                              (searchedFilterList.length ==
                                                this.state
                                                  .IssueSponsoringMinistry
                                                  .length ||
                                                this.state
                                                  .sponsoringMinistryFilterdata
                                                  .length ==
                                                  this.state
                                                    .IssueSponsoringMinistry
                                                    .length))
                                          }
                                          onChange={e =>
                                            this.handleSelectAll(
                                              e,
                                              searchedFilterList,
                                              get(currentFilter, "displayName")
                                            )
                                          }
                                        />
                                        <span class="checkmark1" />
                                      </label>

                                      <label
                                        className="quickfilterselectalltxt"
                                        for={get(currentFilter, "displayName")}
                                      >
                                        Select All
                                      </label>
                                    </div>

                                    <div
                                      style={{
                                        // height: "30em",
                                        overflowX: "hidden"
                                      }}
                                    >
                                      {this.state.quickfilterdata.includes(
                                        "Monitoring Flag"
                                      ) ? (
                                        <>
                                          {this.state.projectFlagsFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }

                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            filter.displayName,
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Recipient State"
                                      ) ? (
                                        <>
                                          {this.state.recipientStateFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Recipient Ministry"
                                      ) ? (
                                        <>
                                          {this.state.recipientCenterFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Zone"
                                      ) ? (
                                        <>
                                          {this.state.issueZoneFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Issue Location"
                                      ) ? (
                                        <>
                                          {this.state.centerStateFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Issue Stages"
                                      ) ? (
                                        <>
                                          {this.state.stagesFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }

                                              return (
                                                <>
                                                  {AgendaIssueStage ? (
                                                    <>
                                                      <div
                                                        className="row"
                                                        style={{
                                                          marginBottom:
                                                            get(
                                                              filter,
                                                              "displayName"
                                                            ).length >
                                                              50 ==
                                                            true
                                                              ? "5%"
                                                              : "3.5%",
                                                          marginTop: "2%",
                                                          display:
                                                            filter.displayName ==
                                                              "Pending with PMG" ||
                                                            filter.displayName ==
                                                              "Pending with RM/RS" ||
                                                            filter.displayName ==
                                                              "Pending with SM" ||
                                                            filter.displayName ==
                                                              "Under PMG Decision"
                                                              ? null
                                                              : "none"
                                                        }}
                                                      >
                                                        <div className="col-12">
                                                          <label class="container1">
                                                            <input
                                                              type="checkbox"
                                                              id={filter.id}
                                                              checked={
                                                                this.state.issueFilterID.includes(
                                                                  filter.id
                                                                ) ||
                                                                this.state.propsCheckedData.includes(
                                                                  filter.id
                                                                )
                                                              }
                                                              onChange={e =>
                                                                this.handlecheckboxcount(
                                                                  e,
                                                                  get(
                                                                    currentFilter,
                                                                    "displayName"
                                                                  ),
                                                                  filter,
                                                                  searchedFilterList,
                                                                  filter.id
                                                                )
                                                              }
                                                            />

                                                            <span class="checkmark1" />
                                                          </label>

                                                          <label
                                                            for={filter.id}
                                                            style={{
                                                              width:
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ).length <=
                                                                  20 ==
                                                                  true &&
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ) !=
                                                                  "PHYSICALLY_COMPLETED"
                                                                  ? "auto"
                                                                  : null,
                                                              fontSize:
                                                                "14.1px",
                                                              marginLeft: "5%",
                                                              position:
                                                                "absolute",
                                                              cursor: "pointer",
                                                              fontFamily:
                                                                "mpsb",
                                                              color: "#3c495a",
                                                              marginTop:
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ).length >
                                                                  50 ==
                                                                true
                                                                  ? null
                                                                  : "0.5%",
                                                              width: "84%"
                                                            }}
                                                          >
                                                            {filter.displayName}
                                                            &nbsp;
                                                            {get(
                                                              filter,
                                                              "count"
                                                            ) &&
                                                            get(
                                                              filter,
                                                              "count"
                                                            ) >= 0
                                                              ? `(${get(
                                                                  filter,
                                                                  "count"
                                                                )})`
                                                              : ""}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <div
                                                        className="row"
                                                        style={{
                                                          marginBottom:
                                                            get(
                                                              filter,
                                                              "displayName"
                                                            ).length >
                                                              50 ==
                                                            true
                                                              ? "5%"
                                                              : "3.5%",
                                                          marginTop: "2%"
                                                        }}
                                                      >
                                                        <div className="col-12">
                                                          <label class="container1">
                                                            <input
                                                              type="checkbox"
                                                              id={filter.id}
                                                              checked={
                                                                this.state.issueFilterID.includes(
                                                                  filter.id
                                                                ) ||
                                                                this.state.propsCheckedData.includes(
                                                                  filter.id
                                                                )
                                                              }
                                                              onChange={e =>
                                                                this.handlecheckboxcount(
                                                                  e,
                                                                  get(
                                                                    currentFilter,
                                                                    "displayName"
                                                                  ),
                                                                  filter,
                                                                  searchedFilterList,
                                                                  filter.id
                                                                )
                                                              }
                                                            />

                                                            <span class="checkmark1" />
                                                          </label>

                                                          <label
                                                            for={filter.id}
                                                            style={{
                                                              width:
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ).length <=
                                                                  20 ==
                                                                  true &&
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ) !=
                                                                  "PHYSICALLY_COMPLETED"
                                                                  ? "auto"
                                                                  : null,
                                                              fontSize:
                                                                "14.1px",
                                                              marginLeft: "5%",
                                                              position:
                                                                "absolute",
                                                              cursor: "pointer",
                                                              fontFamily:
                                                                "mpsb",
                                                              color: "#3c495a",
                                                              marginTop:
                                                                get(
                                                                  filter,
                                                                  "displayName"
                                                                ).length >
                                                                  50 ==
                                                                true
                                                                  ? null
                                                                  : "0.5%",
                                                              width: "84%"
                                                            }}
                                                          >
                                                            {filter.displayName}
                                                            &nbsp;
                                                            {get(
                                                              filter,
                                                              "count"
                                                            ) &&
                                                            get(
                                                              filter,
                                                              "count"
                                                            ) >= 0
                                                              ? `(${get(
                                                                  filter,
                                                                  "count"
                                                                )})`
                                                              : ""}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Issue Category"
                                      ) ? (
                                        <>
                                          {this.state.categoryFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Issue Sponsoring Ministry"
                                      ) ? (
                                        <>
                                          {this.state.sponsoringMinistryFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Project Status"
                                      ) ? (
                                        <>
                                          {this.state.projectTagsFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                      {this.state.quickfilterdata.includes(
                                        "Project Stage"
                                      ) ? (
                                        <>
                                          {this.state.projectStageFilterdata.map(
                                            (filter, index) => {
                                              //const newlist = { ...filter, id: this.randId(index,get(currentFilter, "displayName")) }
                                              return (
                                                <div
                                                  className="row"
                                                  style={{
                                                    marginBottom:
                                                      get(filter, "displayName")
                                                        .length >
                                                        50 ==
                                                      true
                                                        ? "5%"
                                                        : "3.5%",
                                                    marginTop: "2%"
                                                  }}
                                                >
                                                  <div className="col-12">
                                                    <label class="container1">
                                                      <input
                                                        type="checkbox"
                                                        id={filter.id}
                                                        checked={
                                                          this.state.issueFilterID.includes(
                                                            filter.id
                                                          ) ||
                                                          this.state.propsCheckedData.includes(
                                                            filter.id
                                                          )
                                                        }
                                                        onChange={e =>
                                                          this.handlecheckboxcount(
                                                            e,
                                                            get(
                                                              currentFilter,
                                                              "displayName"
                                                            ),
                                                            filter,
                                                            searchedFilterList,
                                                            filter.id
                                                          )
                                                        }
                                                      />

                                                      <span class="checkmark1" />
                                                    </label>

                                                    <label
                                                      for={filter.id}
                                                      style={{
                                                        width:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length <=
                                                            20 ==
                                                            true &&
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ) !=
                                                            "PHYSICALLY_COMPLETED"
                                                            ? "auto"
                                                            : null,
                                                        fontSize: "14.1px",
                                                        marginLeft: "5%",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        fontFamily: "mpsb",
                                                        color: "#3c495a",
                                                        marginTop:
                                                          get(
                                                            filter,
                                                            "displayName"
                                                          ).length >
                                                            50 ==
                                                          true
                                                            ? null
                                                            : "0.5%",
                                                        width: "84%"
                                                      }}
                                                    >
                                                      {filter.displayName ==
                                                      "PHYSICALLY_COMPLETED" ? (
                                                        <>
                                                          PHYSICALLY
                                                          COMPLETED/CC UNDER
                                                          ISSUE
                                                        </>
                                                      ) : (
                                                        <>
                                                          {filter.displayName}
                                                        </>
                                                      )}
                                                      &nbsp;
                                                      {get(filter, "count") &&
                                                      get(filter, "count") >= 0
                                                        ? `(${get(
                                                            filter,
                                                            "count"
                                                          )})`
                                                        : ""}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer
                style={{ borderTop: "1px solid white", marginTop: "-3%" }}
              >
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => {
                    this.setState({
                      MonitoringFlag: [],
                      ProjectStatus: [],
                      ProjectStage: [],
                      RecipientState: [],
                      RecipientMinistry: [],
                      IssueZone: [],
                      IssueLocation: [],
                      selectall: false,
                      IssueStages: [],
                      IssueCategory: [],
                      IssueSponsoringMinistry: [],
                      issueFilterID: [],
                      propsCheckedData: []
                    });
                  }}
                  className="btn-grey quick-filter-button"
                  style={{ marginRight: "8px", paddingLeft: "5.2%" }}
                >
                  Clear All
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={e => {
                    this.handleSubmit();
                  }}
                  className="btn-orange quick-filter-button"
                  style={{ marginLeft: "8px", paddingLeft: "6.3%" }}
                >
                  Apply
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        </React.Fragment>
      )
    );
  }
}

PragatiIssueQuickFilter.propTypes = {
  filterData: PropTypes.array,
  callApiOnSuccess: PropTypes.func
};

PragatiIssueQuickFilter.defaultProps = {
  filterData: [],
  callApiOnSuccess: () => {}
};

export default PragatiIssueQuickFilter;
